import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Table } from 'shared/mui/Table';

export const StyledBox = styled(Box)({
  height: '36px',
  padding: '0 16px',
  display: 'flex',
  alignItems: 'center',
});

export const StyledTable = styled(Table)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  '& thead': { display: 'table-header-group' },
  '& .MuiTableCell-body': {
    borderRight: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderRight: 'none',
    },
    width: '50%',
    verticalAlign: 'top',
    borderBottom: 'none',
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiTableCell-head': {
    borderRight: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderRight: 'none',
    },
    width: '50%',
    padding: '8px 16px',
    backgroundColor: theme.palette.background.default,
  },
}));

export const StyledJsonBox = styled(Box)(({ theme }) => ({
  padding: '0 32px',
  backgroundColor: theme.palette.background.default,
}));
